/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RestoredInputs */

const en_restored = /** @type {(inputs: RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restored`)
};

const es_restored = /** @type {(inputs: RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurado`)
};

/**
* | output |
* | --- |
* | "Restored" |
*
* @param {RestoredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const restored = /** @type {((inputs?: RestoredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RestoredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_restored(inputs)
	return es_restored(inputs)
});